import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Edit as EditIcon } from '@mui/icons-material';
import './styles.scss';
import l from '../../../../lang';
import { Urls } from '../../../../config/urls';
import { accountTypesForSettlements } from '../../../../utils/settlements-utils';
import ButtonCustom from '../../../common/__deprecated__/button-custom';
import { IconButton } from '@mui/material';
import { useEffect, useState } from 'react';
import Input from '../../../common/input';
import { sendEditBankAccount } from '../../../../store/bank-accounts/actions';
import MessageError from '../../../common/message-error';

const BankAccountDetail = ({ detail, loading, error, errorInfo, success, fnEditBankAccount }) => {
  const accountTypes = accountTypesForSettlements();

  const [bankAccount, setBankAccount] = useState(detail);

  const [editAddress, setEditAddress] = useState(false);
  const [values, setValues] = useState({ beneficiaryAddress: bankAccount.beneficiaryAddress || '' });

  useEffect(() => {
    if (editAddress) {
      setEditAddress(false);
      if (success) setBankAccount(success);
    }
  }, [success]);

  return (
    <div className="bank-account-detail">
      <div>
        <div className="bank-account-detail__item">
          <div className="bank-account-detail__subtitle">{l('bankAccounts.bankName')}</div>
          <div>{bankAccount.bankName || '-'}</div>
        </div>
        <div className="bank-account-detail__item">
          <div className="bank-account-detail__subtitle">{l('bankAccounts.bankAccount')}</div>
          <div>{bankAccount.bankAccount || '-'}</div>
        </div>
      </div>
      <div>
        <div className="bank-account-detail__item">
          <div className="bank-account-detail__subtitle">{l('bankAccounts.accountType')}</div>
          <div>{(bankAccount.accountType && accountTypes[bankAccount.accountType]) || '-'}</div>
        </div>
        <div className="bank-account-detail__item">
          <div className="bank-account-detail__subtitle">{l('bankAccounts.bankBranch')}</div>
          <div>{bankAccount.bankBranch || '-'}</div>
        </div>
      </div>
      <div>
        <div className="bank-account-detail__item">
          <div className="bank-account-detail__subtitle">{l('bankAccounts.name')}</div>
          <div>{`${bankAccount.beneficiaryFirstName || ''} ${bankAccount.beneficiaryLastName || ''}`.trim()}</div>
        </div>
        <div className="bank-account-detail__item">
          <div className="bank-account-detail__subtitle">{l('bankAccounts.country')}</div>
          <div>
            <img
              alt={`img-country-${bankAccount.country}`}
              className="bank-account-detail__country"
              src={`${Urls.flags.replace(':code', bankAccount.country)}`}
            />
          </div>
        </div>
      </div>
      <div>
        <div className="bank-account-detail__item">
          <div className="bank-account-detail__subtitle">{l('bankAccounts.document')}</div>
          <div>
            {bankAccount.beneficiaryDocumentType} {bankAccount.beneficiaryDocument}
          </div>
        </div>
        <div className="bank-account-detail__item">
          <div className="bank-account-detail__subtitle">{l('bankAccounts.phone')}</div>
          <div>{bankAccount.beneficiaryPhone || '-'}</div>
        </div>
      </div>
      <div>
        <div className="bank-account-detail__item">
          {!editAddress && (
            <div className="bank-account-detail__subtitle">
              {l('bankAccounts.address')}
              <span>
                <IconButton
                  onClick={() => {
                    setValues({ ...values, beneficiaryAddress: bankAccount.beneficiaryAddress });
                    setEditAddress(!editAddress);
                  }}
                >
                  <EditIcon fontSize="small" />
                </IconButton>
              </span>
            </div>
          )}
          {editAddress ? (
            <div>
              <Input
                name="beneficiaryAddress"
                label={l('bankAccounts.address')}
                onChange={e => setValues({ ...values, beneficiaryAddress: e.target.value })}
                value={values.beneficiaryAddress}
                disabled={loading}
                error={!values.beneficiaryAddress}
              />
            </div>
          ) : (
            <div>{bankAccount.beneficiaryAddress || '-'}</div>
          )}
        </div>
        <div className="bank-account-detail__item">
          <div className="bank-account-detail__subtitle">{l('bankAccounts.city')}</div>
          <div>{bankAccount.beneficiaryCity || '-'}</div>
        </div>
      </div>
      {error && (
        <div className="bank-account-detail__error">
          <MessageError error={error} errorInfo={errorInfo} />
        </div>
      )}
      {editAddress && (
        <div className="change-password__buttons">
          <ButtonCustom
            text={l('common.cancel')}
            name="btn-change-values-cancel"
            size="half-left-square"
            disabled={loading}
            onClick={() => setEditAddress(false)}
          />
          <ButtonCustom
            type="submit"
            name="btn-change-values-save"
            text={l('common.save')}
            variant="contained"
            size="half-right-square"
            disabled={bankAccount.beneficiaryAddress === values.beneficiaryAddress || loading}
            onClick={() => fnEditBankAccount(bankAccount.id, values)}
          />
        </div>
      )}
    </div>
  );
};

BankAccountDetail.propTypes = {
  detail: PropTypes.object,
  fnEditBankAccount: PropTypes.func,
};

const mapStateToProps = state => ({
  loading: state.bankAccounts.editBankAccount.loading,
  error: state.bankAccounts.editBankAccount.error,
  errorInfo: state.bankAccounts.editBankAccount.errorInfo,
  success: state.bankAccounts.editBankAccount.success,
});

const mapDispatchToProps = dispatch => ({
  fnEditBankAccount: (id, values) => dispatch(sendEditBankAccount(id, values)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BankAccountDetail);
